<div
  [@toastAnimation]="showBox"
  class="customize-toast-container {{ customClass }}"
  [style]="{ '--anim': isH5() ? '10px' : '-30px', '--offset': offset, zIndex: zIndex }"
  [class.reverse]="reverse"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  (click)="onToastClick()"
  appLifeObserve
  (lifeContentInit)="viewInit($event)"
>
  <i *ngIf="type" class="toast-type-icon icon-toast-{{ type }}"></i>
  <div class="toast-content">
    <!-- <h2 class="toast-title" *ngIf="title">{{ title }}</h2> -->
    <div class="toast-text">
      <p>{{ message }}</p>
    </div>
  </div>
  <i *ngIf="showClose" class="toast-close icon-close-simple onact96-not" (click)="close()"></i>
  <svg viewBox="25 25 50 50" *ngIf="!showClose">
    <circle
      class="circle"
      cx="50"
      cy="50"
      r="20"
      fill="none"
      stroke-width="8"
      stroke-linecap="round"
      stroke-dasharray="126, 126"
      [style]="'stroke-dashoffset:' + strokeDashoffset"
    ></circle>
  </svg>
</div>
